import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="icons-file-zip_svg__a"
        d="M18.47 6h-2.058V4H4.059v16h12.353v-2h2.059v2c0 1.1-.927 2-2.06 2H4.06C2.926 22 2 21.1 2 20V4c0-1.1.926-2 2.059-2h12.353c1.132 0 2.059.9 2.059 2v2zm-7.807 4.625H8.45V9.35h4.088v1.275l-2.325 2.7h2.4V14.6H8.338v-1.275l2.325-2.7zM14.05 14.6V9.35h1.425v5.25H14.05zm3.125-5.25h2.363c1.162 0 1.95.787 1.95 1.838 0 1.05-.788 1.837-1.95 1.837H18.6V14.6h-1.425V9.35zm2.287 1.275H18.6v1.125h.862c.338 0 .6-.262.6-.563 0-.3-.262-.562-.6-.562z"
      />
    </defs>
    <use
      fill="currentColor"
      fillRule="evenodd"
      xlinkHref="#icons-file-zip_svg__a"
    />
  </svg>
);
